import { Component } from 'react';

import { Select } from '@forms/select';

import { PaymentMethodOption } from './PaymentMethodOption';
import { PaymentMethodValue } from './PaymentMethodValue';
import styles from './SelectPaymentMethod.module.css';
import { TSelectedPayment } from '../EarlyRepayment.reducer';

export class SelectPaymentMethod extends Component<{
    selectRepaymentMethod?: (value: { type: string }) => void;
    options: {
        type: string;
        value: string;
        cardLastDigits: string;
        issuer: string;
        brand: string;
        label: string;
    }[];
    name: string;
    onChange: (selectedPayment: TSelectedPayment) => void;
    disabled?: boolean;
}> {
    handleOnSelectChange = (value: { type: string }, input: any) => {
        input.onChange(value);

        this.props.selectRepaymentMethod!(value);
    };

    render() {
        return (
            <Select
                className={styles.SelectPaymentMethod}
                {...this.props}
                selectOptions={{
                    className: styles.SelectPaymentMethodContainer,
                    classNameSelect: styles.SelectPaymentMethodDropDown,
                    valueComponent: PaymentMethodValue,
                    optionComponent: PaymentMethodOption,
                    onSelect: this.handleOnSelectChange,
                    ...this.props
                }}
            />
        );
    }
}
